import { Component, EventEmitter, Output, viewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel, MatAccordion } from '@angular/material/expansion';
import { convertBooleanToNumbers } from '../../../../common';
import { StoreSelectorsService } from "../../../../services";
import { BlockBaseComponent } from "../../scene-blocks/block-base/block-base.component";
import { actionCRUDScene, actionRemoveInSceneItem } from "../../../../store/actions/user.actions";
import { animationDefault } from '../../../../containers/editor/scene-blocks/block-constants';

import * as _ from "lodash";

@Component({
    selector: 'app-block-animation-group',
    templateUrl: './block-animation-group.component.html',
    styleUrls: ['./block-animation-group.component.scss'],
    standalone: false
})

export class BlockAnimationGroupComponent extends BlockBaseComponent {
    @Output() update: EventEmitter<any> = new EventEmitter<any>();

    accordion = viewChild.required(MatAccordion);

    animationModes = [
        {name: 'In', translator: 'general.animationLabelIn', icon: 'join_left'},
        {name: 'Out', translator: 'general.animationLabelOut', icon: 'join_right'},
        {name: 'Play', translator: 'general.animationLabelPlay', icon: 'join_inner'},
        {name: 'Touch', translator: 'general.animationLabelTouch', icon: 'touch_app'},
    ];
    panelStatus = {};
    isAnimationSliceExist: number = 0;

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog
    ) {
        super(storeSelector);
    }

    override preInit() {
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        if (this.sceneItemSwitched) {
            this.accordion().closeAll();
        }
        this.checkAnimationExistInStore();
        super.componentStoreUpdates();
    }

    toggleAnimation(checked, mode, panel: MatExpansionPanel) {
        if (checked) {
            this.panelStatus[mode] = true;
            this.addAnimation(mode);
            setTimeout(() => {
                if (panel) {
                    panel.open();
                }
            }, 300);
        } else {
            this.panelStatus[mode] = false;
            this.removeAnimation(mode);
            if (panel) {
                panel.close();
            }
        }
        this.onAnimationUpdate();
    }

    addAnimation(mode) {
        if (!this.isAnimationSliceExist) return;     
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: mode,
                value: animationDefault[0][mode],
                storePath: 'Data[0].Animation[0]',
            }]
        });
    }

    removeAnimation(mode) {
        // const removedAll = this.animationModes.every((_mode) => this.panelStatus[_mode.name] == false);
        // if (removedAll) {
        //     this.storeSelector.dispatch(actionRemoveInSceneItem({
        //         sceneId: this.sceneId,
        //         sceneItemId: this.sceneItemId,
        //         values: [{
        //             key: 'Animation',
        //             value: null,
        //             storePath: 'Data[0]'
        //         }]
        //     }));
        // } else {
        //     this.storeSelector.dispatch(actionRemoveInSceneItem({
        //         sceneId: this.sceneId,
        //         sceneItemId: this.sceneItem.$.id,
        //         values: [{
        //             key: mode,
        //             value: null,
        //             storePath: 'Data[0].Animation[0]'
        //         }]
        //     }));
        // }
        this.storeSelector.dispatch(actionRemoveInSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: mode,
                value: null,
                storePath: 'Data[0].Animation[0]'
            }]
        }));
    }

    onAnimationUpdate($event = null) {
        // Handle the animation update event
        setTimeout(() => {
            if (this.update.observed) {
                this.update.emit();
            }
        });
    }

    private checkAnimationExistInStore() {
        this.isAnimationSliceExist = Number(convertBooleanToNumbers(this.sceneItem?.Data?.[0]?.Animation?.length > 0));
        if (this.isAnimationSliceExist) {
            const animationData = this.sceneItem?.Data?.[0]?.Animation[0];
            this.animationModes.forEach((_mode) => {
                this.panelStatus[_mode.name] = !!animationData[_mode.name];
            });
        }
    }

    override destroy() {
        super.destroy();
        this.storeSelector.dispatch(actionCRUDScene({
            data: null
        }));
    }
}
